module.exports = __webpack_public_path__ + "img/icon_shopping_pre.cf188045.png";